import React, { useMemo } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchUserTalentPools } from "../../../services/api/talentPool";

const CHIP_COLORS = [
  { bg: "bg-orange-100", text: "text-orange-700" },
  { bg: "bg-blue-100", text: "text-blue-700" },
  { bg: "bg-purple-100", text: "text-purple-700" },
  { bg: "bg-indigo-100", text: "text-indigo-700" },
  { bg: "bg-teal-100", text: "text-teal-700" },
];

const TalentPools = () => {
  const { id: userId } = useParams();
  const navigate = useNavigate();

  const { data: talentPoolsData, isLoading } = useQuery({
    queryKey: ["userTalentPools", userId],
    queryFn: () => fetchUserTalentPools(userId),
    enabled: !!userId,
  });

  const pools = talentPoolsData?.data || [];

  const colorAssignments = useMemo(
    () =>
      pools.map((_, index) =>
        index < CHIP_COLORS.length
          ? CHIP_COLORS[index]
          : CHIP_COLORS[Math.floor(Math.random() * CHIP_COLORS.length)],
      ),
    [pools],
  );

  return (
    <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
      <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Talent Pools</h6>
      </div>

      {isLoading ? (
        <p className="text-gray-400">Loading...</p>
      ) : pools.length === 0 ? (
        <p className="text-gray-400 ">No talent pools assigned.</p>
      ) : (
        <div className="flex flex-wrap gap-4 mt-3">
          {pools.map((pool, index) => {
            const color = colorAssignments[index];
            return (
              <p
                key={pool.id}
                className={`font-light ${color.bg} ${color.text} rounded-sm px-3 py-[4px] w-fit cursor-pointer hover:opacity-80`}
                onClick={() => navigate(`/workForce/talentPool/engineers/${pool.id}`)}
              >
                {pool.name}
              </p>
            );
          })}
        </div>
      )}
    </BaseCard>
  );
};

export default TalentPools;
